<template>
    <div>
        <div style="margin-top: 10px;background-color: #1BF1E6">
            <h5 style="text-align: center">今日打卡{{today_clock_count}}人</h5>
        </div>
        <div>
            <div class="question_reply_item" v-for="data in clock_records" :key="data">
                <div class="question_reply_item_base_info">
                    <div class="question_reply_item_base_info_layout">
                        <router-link tag="a" :to="{ name: 'user', params: { id: data.user.id } }">
                            <img :src="data.user.avatar_url" class="avatar"/>
                            {{ data.user.name }}
                        </router-link>
                    </div>
                    <!--<span class="thumb">-->
        <!--<a href="javascript:;" class="thumb_button">-->
        <!--<i class="far fa-thumbs-up"></i>-->
        <!--</a>-->
        <!--| 12-->
        <!--</span>-->
                </div>
                <div class="main_reply">
                    <div v-html="data.content"></div>
                    <div class="reply_base_info_div">
                        <span class="question_reply_item_created_time margin-right-10">于{{ data.create_date }}</span>
                        <span class="question_reply_item_created_time">已坚持56天</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </div>
</template>

<script>
    import clockApi from '@/api/clock/clock.js'

    export default {
        name: "clock",
        data() {
            return {
                today_clock_count: 0,
                clock_records: [],
            }
        },
        mounted: function () {
            let args = {
                'course_id': this.$route.params.id
            }
            clockApi.get_clock_record(args).then(res => {
                console.log(res)
                this.today_clock_count = res.data.today_clock_count
                this.clock_records = res.data.records
            })
        }
    }
</script>

<style scoped>
    .question_reply_item {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        /*justify-content: space-between;*/
    }

    .main_reply {
        display: flex;
        flex-direction: column;
        margin-left: 50px;
        border-bottom: 1px solid #eee;
    }

    .question_reply_item_base_info {
        display: flex;
        justify-content: space-between;
    }

    .question_reply_item_base_info_layout {
        display: flex;
        align-items: center;
    }

    .author {
        color: #367eba;
        font-size: 13px;
    }

    .author:hover {
        color: #6CF;
    }

    .content_p {
        margin: 20px 0 20px;
        font-size: 15px;
        line-height: 26px;
        word-break: break-all;
    }


    .reply_base_info_div {
        /*display: flex;*/
        justify-content: space-between;
    }

    .question_reply_item_created_time {
        display: inline-block;
        color: #a4a4a4;
        padding: 15px 0 10px;
    }

    .up_reply_button {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;
        /*width: 6%;*/
        font-size: 16px;
        color: #9f9c99;
    }

    .thumb {
        align-self: center;
    }

    .thumb_button {
        color: #9f9c99;
    }

    .thumb_button:hover {
        color: #9f9c99;
    }

    .reply_button {
        font-size: 10px;
        color: #666;
        padding: 15px 0 10px;
        margin-bottom: 20px;
    }

    .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
    }


    .content_p >>> img {
        max-width: 100%;
        height: auto !important;
    }
</style>